












































































import Vue from "vue";
import anime from "animejs";
import debounce from "lodash.debounce";

import {
  IState,
  IFilter,
  IPost,
  IDatesFilter,
  ITagsFilter,
  IPagination,
} from "./store/state";
import { setQuery, setFilterOpen, search } from "./store/actions";

import BloglistFilter from "./components/BloglistFilter.vue";
import BlogPost from "./components/BlogPost.vue";
import SelectedFilters from "./components/SelectedFilters.vue";
import ListPagination from "./components/ListPagination.vue";

// Interfaces for component typechecking!
interface AppData {
  filterOpen: boolean;
  oldPage: number;
}

interface AppMethods {
  closeOpenFilter(): void;
  search(e: Event): void;
  beforeOpen(el: HTMLElement): void;
  animateOpen(el: HTMLElement, done: any): void;
  animateClose(el: HTMLElement, done: any): void;
  windowResized(): void;
}

interface AppComputed {
  dates: IDatesFilter;
  tags: ITagsFilter;
  posts: IPost[];
  rssUrl: string;
  subscribeUrl: string;
  pagination: IPagination;
  noHits: string;
}

interface AppProps {}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
  name: "app",
  created() {
    document.addEventListener("click", (e) => {
      if (!(this.$refs.bloglistApp as Element).contains(e.target as Element)) {
        this.closeOpenFilter();
      }
    });
    document.addEventListener("keyup", (e) => {
      if (e.which === 27) {
        this.closeOpenFilter();
      }
    });
    window.addEventListener("resize", debounce(this.windowResized, 50));
    this.windowResized();
  },
  data() {
    return {
      filterOpen: false,
      oldPage: (this.$store.state as IState).pagination.current || 0,
    };
  },
  watch: {
    pagination: {
      handler(newPagination: IPagination) {
        if (this.oldPage !== newPagination.current) {
          (this.$refs.bloglistApp as HTMLElement).scrollIntoView();
          this.oldPage = newPagination.current;
        }
      },
      deep: true,
    },
  },
  methods: {
    windowResized() {
      if (window.outerWidth >= 768) {
        this.filterOpen = true;
      } else {
        this.filterOpen = false;
      }
    },
    closeOpenFilter() {
      if (this.$store.getters.openFilterName) {
        this.$store.dispatch(
          setFilterOpen({
            name: this.$store.getters.openFilterName,
            open: false,
          })
        );
      }
    },
    search(e) {
      e.preventDefault();
      this.$store.dispatch(search(undefined));
    },
    beforeOpen(el) {},
    animateOpen(el, done) {
      anime({
        targets: el,
        height: [0, el.offsetHeight],
        duration: 250,
        elasticity: 0,
        easing: "linear",
        complete: () => {
          el.style.height = "";
          done();
        },
      });
    },
    animateClose(el, done) {
      anime({
        targets: el,
        height: [el.offsetHeight, 0],
        duration: 250,
        elasticity: 0,
        easing: "linear",
        complete: () => {
          el.style.height = "";
          done();
        },
      });
    },
  },
  computed: {
    noHits() {
      return (this.$store.state as IState).noHits;
    },
    pagination() {
      return (this.$store.state as IState).pagination;
    },
    posts() {
      return (this.$store.state as IState).posts;
    },
    dates() {
      return (this.$store.state as IState).filters.dates;
    },
    tags() {
      return (this.$store.state as IState).filters.tags;
    },
    rssUrl() {
      return (this.$store.state as IState).rssUrl;
    },
    subscribeUrl() {
      return (this.$store.state as IState).subscribeUrl;
    },
  },
  components: {
    BloglistFilter,
    BlogPost,
    ListPagination,
    SelectedFilters,
  },
});
